
import { MapLocation } from '@/types/location';

// 9Round Male Gym Locations
export const nineRoundMaleGyms: MapLocation[] = [
  {
    id: 7001,
    name: "9Round - Riyadh (Al Narjis Male)",
    type: "Gym",
    devices: 1,
    coordinates: [24.74492622128994, 46.724014220241095],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Landscape Screens",
    gender: "Male",
    ageRange: "20-45",
    orientation: "Landscape",
    segment: "Fitness"
  },
  {
    id: 7002,
    name: "9Round - Riyadh (Al Malqa Male)",
    type: "Gym",
    devices: 1,
    coordinates: [24.805946270307466, 46.61080083742954],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Landscape Screens",
    gender: "Male",
    ageRange: "20-45",
    orientation: "Landscape",
    segment: "Fitness"
  },
  {
    id: 7003,
    name: "9Round - Riyadh (Qurtubah Male)",
    type: "Gym",
    devices: 1,
    coordinates: [24.80307423948577, 46.738346064417655],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Landscape Screens",
    gender: "Male",
    ageRange: "20-45",
    orientation: "Landscape",
    segment: "Fitness"
  },
  {
    id: 7004,
    name: "9Round - Riyadh (Shubrah Exit 26 Male)",
    type: "Gym",
    devices: 1,
    coordinates: [24.563966751858377, 46.64812882208829],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Landscape Screens",
    gender: "Male",
    ageRange: "20-45",
    orientation: "Landscape",
    segment: "Fitness"
  },
  {
    id: 7005,
    name: "9Round - Riyadh (Al Rabwa Male)",
    type: "Gym",
    devices: 1,
    coordinates: [24.692347185916507, 46.764561361135115],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Landscape Screens",
    gender: "Male",
    ageRange: "20-45",
    orientation: "Landscape",
    segment: "Fitness"
  },
  {
    id: 7006,
    name: "9Round - Riyadh (AL Mathar Male)",
    type: "Gym",
    devices: 1,
    coordinates: [24.683275320268898, 46.672805236983024],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Landscape Screens",
    gender: "Male",
    ageRange: "20-45",
    orientation: "Landscape",
    segment: "Fitness"
  },
  {
    id: 7007,
    name: "9Round - Riyadh (Al Manar Imam Shafi Male)",
    type: "Gym",
    devices: 1,
    coordinates: [24.72750277330455, 46.785241027864195],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Landscape Screens",
    gender: "Male",
    ageRange: "20-45",
    orientation: "Landscape",
    segment: "Fitness"
  },
  {
    id: 7008,
    name: "9Round - Riyadh (Al Nasim Sharqi Male)",
    type: "Gym",
    devices: 1,
    coordinates: [24.74765710911273, 46.823852456984646],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Landscape Screens",
    gender: "Male",
    ageRange: "20-45",
    orientation: "Landscape",
    segment: "Fitness"
  },
  {
    id: 7009,
    name: "9Round - Riyadh (Al Nahda Male)",
    type: "Gym",
    devices: 1,
    coordinates: [24.756020460705, 46.7917889889789],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Landscape Screens",
    gender: "Male",
    ageRange: "20-45",
    orientation: "Landscape",
    segment: "Fitness"
  },
  {
    id: 7010,
    name: "9Round - Riyadh (Al Laban Male)",
    type: "Gym",
    devices: 1,
    coordinates: [24.618558150444375, 46.5433100582343],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Landscape Screens",
    gender: "Male",
    ageRange: "20-45",
    orientation: "Landscape",
    segment: "Fitness"
  },
  {
    id: 7011,
    name: "9Round - Riyadh (Hittin Male)",
    type: "Gym",
    devices: 1,
    coordinates: [24.7688012436468, 46.58854532517021],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Landscape Screens",
    gender: "Male",
    ageRange: "20-45",
    orientation: "Landscape",
    segment: "Fitness"
  },
  {
    id: 7012,
    name: "9Round - Riyadh (Al Yarmuk Male)",
    type: "Gym",
    devices: 1,
    coordinates: [24.79547981052057, 46.77510960242063],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Landscape Screens",
    gender: "Male",
    ageRange: "20-45",
    orientation: "Landscape",
    segment: "Fitness"
  },
  {
    id: 7013,
    name: "9Round - Riyadh (Munsiyah Male)",
    type: "Gym",
    devices: 1,
    coordinates: [24.82176393421612, 46.77308942024109],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Landscape Screens",
    gender: "Male",
    ageRange: "20-45",
    orientation: "Landscape",
    segment: "Fitness"
  },
  {
    id: 7014,
    name: "9Round - Riyadh (Al Qarwan Male)",
    type: "Gym",
    devices: 1,
    coordinates: [24.82518518034007, 46.56527627975892],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Landscape Screens",
    gender: "Male",
    ageRange: "20-45",
    orientation: "Landscape",
    segment: "Fitness"
  },
  {
    id: 7015,
    name: "9Round - Riyadh (Al Nakhil Male)",
    type: "Gym",
    devices: 1,
    coordinates: [24.741432588046926, 46.6193062754618],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Landscape Screens",
    gender: "Male",
    ageRange: "20-45",
    orientation: "Landscape",
    segment: "Fitness"
  },
  {
    id: 7016,
    name: "9Round - Riyadh (Olaya Male)",
    type: "Gym",
    devices: 1,
    coordinates: [24.704585711525937, 46.679133426375635],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Landscape Screens",
    gender: "Male",
    ageRange: "20-45",
    orientation: "Landscape",
    segment: "Fitness"
  },
  {
    id: 7017,
    name: "9Round - Riyadh (Al Tawun Male)",
    type: "Gym",
    devices: 1,
    coordinates: [24.77268865106751, 46.69732059325297],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Landscape Screens",
    gender: "Male",
    ageRange: "20-45",
    orientation: "Landscape",
    segment: "Fitness"
  },
  {
    id: 7018,
    name: "9Round - Riyadh (Al Waha Male)",
    type: "Gym",
    devices: 1,
    coordinates: [24.744911590485795, 46.724170825297136],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Landscape Screens",
    gender: "Male",
    ageRange: "20-45",
    orientation: "Landscape",
    segment: "Fitness"
  },
  {
    id: 7019,
    name: "9Round - Jeddah (Al Faisaliah Male)",
    type: "Gym",
    devices: 1,
    coordinates: [21.585279727676067, 39.167625138268015],
    region: "Jeddah",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Landscape Screens",
    gender: "Male",
    ageRange: "20-45",
    orientation: "Landscape",
    segment: "Fitness"
  },
  {
    id: 7020,
    name: "9Round - Jeddah (Al Basaten Male)",
    type: "Gym",
    devices: 1,
    coordinates: [21.684867610834107, 39.11867532024109],
    region: "Jeddah",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Landscape Screens",
    gender: "Male",
    ageRange: "20-45",
    orientation: "Landscape",
    segment: "Fitness"
  },
  {
    id: 7021,
    name: "9Round - Jeddah (Al Samer Male)",
    type: "Gym",
    devices: 1,
    coordinates: [21.58142152650859, 39.229598733803485],
    region: "Jeddah",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Landscape Screens",
    gender: "Male",
    ageRange: "20-45",
    orientation: "Landscape",
    segment: "Fitness"
  },
  {
    id: 7022,
    name: "9Round - Jeddah (Al Hamadaniyyah Male)",
    type: "Gym",
    devices: 1,
    coordinates: [21.786709159778326, 39.207388459814304],
    region: "Jeddah",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Landscape Screens",
    gender: "Male",
    ageRange: "20-45",
    orientation: "Landscape",
    segment: "Fitness"
  },
  {
    id: 7023,
    name: "9Round - Khobar (Rakah Male)",
    type: "Gym",
    devices: 1,
    coordinates: [26.37026546654579, 50.208460817372746],
    region: "Eastern",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Landscape Screens",
    gender: "Male",
    ageRange: "20-45",
    orientation: "Landscape",
    segment: "Fitness"
  },
  {
    id: 7024,
    name: "9Round - Dammam (Al Faisaliah Male)",
    type: "Gym",
    devices: 1,
    coordinates: [26.406846263871035, 50.059966662737],
    region: "Eastern",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Landscape Screens",
    gender: "Male",
    ageRange: "20-45",
    orientation: "Landscape",
    segment: "Fitness"
  }
];
